import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "form"];

  open(event) {
    event.preventDefault();
    if (event.currentTarget?.disabled) return;

    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  confirm(event) {
    event.preventDefault();
    if (!this.hasFormTarget) return;

    this.dialogTarget.close();
    this.formTarget.requestSubmit();
  }
}
